/* eslint-disable no-param-reassign */
import { produce } from 'immer';
import { calloutModalClose } from '../../../analytics';

export default (set, get, feature, callout) => set(produce(get(), (draft) => {
  if (!draft.digitalData) {
    draft.digitalData = { event: [] };
  }

  const trackCalloutModalClose = { feature, callout };

  draft.digitalData.calloutModalClose = trackCalloutModalClose;

  calloutModalClose(trackCalloutModalClose);
}), false, { type: 'TRACK_CALLOUT_MODAL_CLOSE' });
